import { I18nFragment, ResponsiveDialog } from '@diagentech/exprworks-ui-components';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import React, { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from '@/App/hooks';
import { theme } from '@/App/theme';
import { CloseIconButton } from '@/components/common/CloseIconButton';
import { DefaultFormButton } from '@/components/common/DefaultFormButton';
import { ConsultationsContent } from '@/components/consultations/ConsultationsContent';
import { selectUiState } from '@/features/ui/selectUiState';
import { setShowConsultations } from '@/features/ui/uiSlice';

export const CONSULTATIONS_DIALOG_ID = 'consultations-dialog';

export const ConsultationsDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const { showConsultations } = useAppSelector(selectUiState);

  const onClose = useCallback(() => {
    dispatch(setShowConsultations(false));
  }, [dispatch]);

  return (
    <ResponsiveDialog
      id={CONSULTATIONS_DIALOG_ID}
      theme={theme}
      breakpoints={{ maxWidth: 'lg' }}
      fullWidth
      open={showConsultations}
      aria-labelledby="consultations-dialog-title"
      onClose={onClose}
    >
      <DialogTitle id="consultations-dialog-title">
        <Grid
          container
          direction="row"
          sx={{
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Grid>
            <I18nFragment id="SH.PG.CONSULTATIONS" />
          </Grid>
          <Grid>
            <CloseIconButton onClick={onClose} />
          </Grid>
        </Grid>
      </DialogTitle>
      <Divider />
      <DialogContent
        style={{
          minHeight: '70vh',
        }}
      >
        <ConsultationsContent />
      </DialogContent>
      <DialogActions>
        <DefaultFormButton id="SH.BTN.CLOSE" color="primary" onClick={onClose} />
      </DialogActions>
    </ResponsiveDialog>
  );
};
